export function shortHash(str, left = 6, right = 4) {
  if (!str) return "";
  const value = String(str);
  if (value.length <= left + right + 1) return value;
  return `${value.slice(0, left)}...${value.slice(-right)}`;
}

export function shortUuid(str) {
  if (!str) return "";
  const value = String(str);
  if (value.includes("-") && value.length >= 12) {
    return `${value.slice(0, 8)}...${value.slice(-4)}`;
  }
  return shortHash(value, 8, 4);
}

export function formatDateTime(date) {
  if (!date) return "";
  const dt = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(dt.getTime())) return String(date);
  return dt.toLocaleString();
}

export function titleCase(str) {
  if (!str) return "";
  return String(str)
    .replace(/[_-]+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function safeText(str) {
  if (str === null || str === undefined) return "";
  return String(str);
}
